import { useRouteMatch } from 'react-router'
import { routes } from 'domains/onboarding/routing/routes'

export const useHideNavbarDueToPendingOnboarding = () =>
  // We only hide it on the initial onboarding page as they still don't have a retailer (warehouse) setup, so nav will not work
  !!useRouteMatch(routes['onboarding-initial-setup'])
